import { render, staticRenderFns } from "./PaidEditModal.vue?vue&type=template&id=181006b6&"
import script from "./PaidEditModal.vue?vue&type=script&lang=js&"
export * from "./PaidEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports